import { RequestError, RequestErrorArgs } from "./RequestError"

export class ClientError extends RequestError {
  constructor(args: RequestErrorArgs) {
    super(args)
    this.name = "ClientError"
  }
}
